/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Balancing_Display_No_SortingInputs */



/**
* | output |
* | --- |
* | "Do not sort" |
*
* @param {Manual_Balancing_Display_No_SortingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const manual_balancing_display_no_sorting = /** @type {((inputs?: Manual_Balancing_Display_No_SortingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Balancing_Display_No_SortingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Do not sort")
	return /** @type {LocalizedString} */ ("Ne pas trier")
});